import React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { Field, reduxForm } from "redux-form";

// core components
import AllTranslationsRequiredMessage from "../../configuration/components/AllTranslationsRequiredMessage";
import FormFields from './formFields';
import GridItem from "components/grid/gridItem";
import ActionsContainer from "components/form/ActionsContainer";
import FormContainer from "views/configuration/components/FormContainer";
import CancelButton from "views/configuration/components/CancelButton";
import SubmitButton from "views/configuration/components/SubmitButton";

// action
import { create } from "actions/gender/create";
import { updatePosition } from 'actions/gender/updatePosition';
import FormTranslator from "../../../components/translator/formTranslator";

function Form(props) {
    const {
        gender,
        closeDialog,
        create,
        createLoading,
        intl,
        isSubGender,
        submitting,
        values,
        requiredFields,
        position,
        allGenders,
        updatePosition,
    } = props;

    const isFormValid = values && !!(requiredFields.length && requiredFields.every((input) => {
        let translation = input.split('.');
        return values['translations'][translation[1]] && values['translations'][translation[1]][translation[2]];
    }));

    function submit(e) {
        e.preventDefault();
        if (!isFormValid) {
            return;
        }

        if (gender && isSubGender) {
            values.parent = gender["@id"];
        }
        if (position) {
            values.position = position + 1;
        }

        create(values).then(() => {
            if (position) {
                const formattedGenders = allGenders.map((gender, index) => {
                    const afterPosition = index >= position;

                    return  {
                        'id': gender.id,
                        'position': afterPosition ? index + 2 : index + 1,
                    };
                });

                updatePosition({'genders': formattedGenders});
            }
        });
    }
    const renderTranslationForm = (index, code) => {
        if (requiredFields.indexOf(`translations.${code}.value`) === -1) {
            requiredFields.push(`translations.${code}.value`);
        }
        return (
            <div>
                <GridItem xs={12} sm={12}>
                    <Field
                        component={FormFields}
                        name={`translations.${code}.value`}
                        label={intl.formatMessage({id: gender ? "gender.form.label.sub.name" : "gender.form.label.name"})}
                        type={"text"}
                        placeholder={intl.formatMessage({id: "gender.form.placeholder.name"})}
                        required
                    />
                </GridItem>
            </div>
        );
    };

    return (
        <form onSubmit={(e) => submit(e)}>
            <FormContainer>
                <AllTranslationsRequiredMessage />
                {gender && (
                    <GridItem xs={12} sm={12}>
                        {gender}
                    </GridItem>
                )}
                <GridItem xs={12} sm={12}>
                    <FormTranslator formGenerator={renderTranslationForm} />
                </GridItem>
            </FormContainer>
            <ActionsContainer>
                <CancelButton onClick={closeDialog} />
                <SubmitButton
                    disabled={!isFormValid || submitting}
                    loading={createLoading}
                />
            </ActionsContainer>
        </form>
    )
}

const mapStateToProps = state => {
    return {
        createLoading: state.gender.create.loading,
        values: state.form && state.form.addGender && state.form.addGender.values,
    }
};

const mapDispatchToProps = dispatch => ({
    create: (values) => dispatch(create(values)),
    updatePosition: (params) => dispatch(updatePosition(params)),
    requiredFields: [],
});

export default reduxForm({
    form: "addGender",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(Form)));
